<template>
  <div>
    <el-dialog title="订单满意度评价" :visible.sync="commentVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <div class="comment-row">
          <div class="row-label">执行质量</div>
          <div class="row-icon" :class="{ 'row-icon-active': commentParams.qualityScoreValue === '满意' }">
            <i class="iconfont iconlike-fill" @click="qualityClick('满意')"></i>
          </div>
          <div class="row-icon" :class="{ 'row-icon-active': commentParams.qualityScoreValue === '不满意' }">
            <i class="iconfont iconunlike-fill" @click="qualityClick('不满意')"></i>
          </div>
        </div>
        <div class="comment-row">
          <div class="row-label">执行速度</div>
          <div class="row-icon" :class="{ 'row-icon-active': commentParams.speedScoreValue === '满意' }">
            <i class="iconfont iconlike-fill" @click="speedClick('满意')"></i>
          </div>
          <div class="row-icon" :class="{ 'row-icon-active': commentParams.speedScoreValue === '不满意' }">
            <i class="iconfont iconunlike-fill" @click="speedClick('不满意')"></i>
          </div>
        </div>
        <div class="comment-row comment-remark">
          <div class="row-label">备注</div>
          <div class="row-textarea">
            <el-input type="textarea" rows="3" resize="none" v-model="commentParams.tmComment"></el-input>
          </div>
        </div>
        <div class="comment-btn">
          <el-button class="btn-red" size="small" @click="confirmComment" :loading="btnLoading">提交</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'order-comment-dialog',
  data () {
    return {
      btnLoading: false,
      commentVisible: false,
      commentParams: {
        applyId: '',
        qualityScoreValue: '',
        speedScoreValue: '',
        tmComment: ''
      },
      applyId: '',
      commentType: ''
    }
  },
  methods: {
    commentShow (applyId) {
      this.commentVisible = true
      this.clearForm()
      this.applyId = applyId
      console.log(this.applyId)
    },

    commentHidden () {
      this.commentVisible = false
    },

    qualityClick (val) {
      this.commentParams.qualityScoreValue = val
    },

    speedClick (val) {
      this.commentParams.speedScoreValue = val
    },

    clearForm () {
      this.commentParams = {
        applyId: '',
        qualityScoreValue: '',
        speedScoreValue: '',
        tmComment: ''
      }
    },

    // 提交评价
    confirmComment () {
      if (this.btnLoading) {
        return
      }
      if (!this.commentParams.qualityScoreValue || !this.commentParams.speedScoreValue) {
        this.$message.error('请评价')
        return
      }
      if (typeof (this.applyId) !== 'object') {
        // 单个订单评价
        this.commentParams.applyId = this.applyId || this.$route.query.applyId
        this.btnLoading = true
        this.$store.dispatch('orderComment', this.commentParams).then(res => {
          this.btnLoading = false
          if (res.data.resultCode === '0') {
            this.commentHidden()
            this.$emit('commentSuccess')
          }
        }).catch(() => {
          this.btnLoading = false
        })
      } else {
        // 批量评价
        let params = []
        this.applyId.forEach(item => {
          params.push({
            applyId: item,
            qualityScoreValue: this.commentParams.qualityScoreValue,
            speedScoreValue: this.commentParams.speedScoreValue,
            tmComment: this.commentParams.tmComment
          })
        })
        this.btnLoading = true
        this.$store.dispatch('orderCommentBatch', params).then(res => {
          this.btnLoading = false
          if (res.data.resultCode === '0') {
            this.commentHidden()
            this.$emit('commentSuccess')
          }
        }).catch(() => {
          this.btnLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .row-label {
    width: 60px;
    text-align: right;
    margin-right: 50px;
  }

  .row-icon {
    margin-right: 30px;

    i {
      font-size: 24px;
      cursor: pointer;
      color: #aaa;

      &:hover {
        color: $base-red;
      }
    }
  }

  .row-icon-active {
    i {
      color: $base-red;
    }
  }
}

.comment-remark {
  align-items: flex-start;
  width: 100%;

  .row-textarea {
    width: calc(100% - 120px);
  }

  .row-label {
    padding-top: 6px;
  }
}

.comment-btn {
  text-align: center;
  margin-top: 20px;

  .el-button {
    width: 100px;
  }
}
</style>
